import {Injectable} from '@angular/core';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {MedicalRecordVisitReasonModel} from '../../../api/model/medicalRecordVisitReason.model';
import {MedicalRecordVisitReasonConverter} from '../../../api/converter/medicalRecordVisitReason.converter';

@Injectable({providedIn: 'root'})
export class MedicalRecordVisitReasonDataService
    extends AbstractDataServiceV2<MedicalRecordVisitReasonModel, MedicalRecordVisitReasonConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: MedicalRecordVisitReasonConverter) {
        super('MedicalRecordVisitReason', http, httpUrlGenerator, logger, config, converter);
    }
}
